import { gql as t } from "@apollo/client";
const a = t`
  mutation ConfirmTxn($txnHash: String!) {
    confirmTxn(input: { txnHash: $txnHash }) {
      txnResult {
        eventName
      }
    }
  }
`;
export {
  a as default
};
//# sourceMappingURL=confirmTransaction.js.map
